export const EmbeddedGuideflow = ({ id }) => {
  return (
    <div
      style={{
        position: "relative",
        paddingBottom: "calc(57% + 50px)",
        height: "0px",
      }}
    >
      <iframe
        id={id}
        src={"https://app.guideflow.com/embed/" + id}
        width="100%"
        height="100%"
        style={{
          overflow: "hidden",
          position: "absolute",
          border: "none",
        }}
        scrolling="no"
        allow="clipboard-read; clipboard-write"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen
        allowtransparency="true"
      ></iframe>
    </div>
  );
};
